import React from "react";

// The one footer for question navigation. Native buttons, a single click path per action,
// and a busy state that is shown only while Continue's own save is in progress.
export const FlowNav = ({ onBack, onSkip, onContinue, canBack, showSkip, busy, continueLabel = "Continue" }) => (
  <div className="v142-nav" data-testid="v142-flow-nav">
    <button type="button" className="v142-ghost v142-nav-ctl" data-testid="v142-back-btn" onClick={onBack} disabled={!canBack}>
      Back
    </button>
    <div className="v142-nav-right">
      {showSkip && (
        <button type="button" className="v142-skip v142-nav-ctl" data-testid="v142-skip-btn" onClick={onSkip}>
          Skip for now
        </button>
      )}
      <button
        type="button"
        className={`v142-btn v142-nav-ctl${busy ? " is-busy" : ""}`}
        data-testid="v142-continue-btn"
        onClick={onContinue}
        disabled={busy}
        aria-busy={busy ? "true" : undefined}
        aria-disabled={busy ? "true" : undefined}
        data-state={busy ? "saving" : "idle"}
      >
        {busy ? "Saving…" : continueLabel}
      </button>
    </div>
  </div>
);
